import { render, staticRenderFns } from "./regalo_perfecto.vue?vue&type=template&id=efff3d38"
import script from "./regalo_perfecto.vue?vue&type=script&lang=js"
export * from "./regalo_perfecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports